/**
 * Organizations for which prompt category chips are hidden.
 * This is a temporary commercial agreement — chips are not enabled for these orgs.
 * Contact: Equipo Crehana AI — CBC-4009
 */
export var HIDDEN_CHIPS_SLUGS = ['universidad-posadas', 'posadas-pruebas-integracion-sap'];